/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';
import { get, orderBy, isEmpty } from 'lodash';
import { Base64 } from 'js-base64';

import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import dateFormat from 'dateformat';

import * as actions from '../../../store/modules/auth/actions';

import 'react-toastify/dist/ReactToastify.css';

import { displayErrors } from '../../../util/diversos';
import { fillColumns } from '../../../components/table';
import { Input100px, Input155px, Input200px } from '../../../styles/inputGroup';

import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Card from '../../../components/card';
import Loading from '../../loading';
// eslint-disable-next-line import/no-cycle
import CadastroCte from './cadastroCTe';
import ConsultaConversaoCfop from '../conversaoCfop/consultaConversaoCfop';

export default function ConsultaCTe({ menuMode, childToParent, empresaCnpj }) {
  const [isLoading, setIsLoading] = useState(false);

  const [cnpjEmpresa, setCnpjEmpresa] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [serieEmpresa, setSerieEmpresa] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [ufEmpresa, setUfEmpresa] = useState('');

  const [idSelecionado, setIdSelecionado] = useState('');

  // eslint-disable-next-line no-unused-vars
  const [empresaTipoAmbiente, setEmpresaTipoAmbiente] = useState('');

  const [listaArquivosZipar, setListaArquivosZipar] = useState([]);

  const [showConsultaConversaoCfop, setShowConsultaConversaoCfop] = useState(false);

  const [dataTableListNFeItem, setDataTableListNFeItem] = useState([]);

  const [motivoCancelamento, setMotivoCancelamento] = useState('');
  const [sequenciaEventoCartaCorrecao, setSequenciaEventoCartaCorrecao] = useState('');
  const [numeroLoteCartaCorrecao, setNumeroLoteCartaCorrecao] = useState('1');
  const [cnpjCartaCorrecao, setCnpjCartaCorrecao] = useState('');
  const [chaveAcesso, setChaveAcesso] = useState('');
  const [showCadastro, setShowCadastro] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const [dataTableList, setDataTableList] = useState([]);
  const [dataTableListCartaCorrecao, setDataTableListCartaCorrecao] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showConfirmCancelamentoDialog, setShowConfirmCancelamentoDialog] = useState(false);
  const [showConfirmCartaCorrecaoDialog, setShowConfirmCartaCorrecaoDialog] = useState(false);
  const [selectedItens, setSelectedItens] = useState(null);
  const [findDataInicial, setFindDataInicial] = useState(null);
  const [findDataFinal, setFindDataFinal] = useState(null);
  const [sortField, setSortField] = useState('item');
  const [sortOrder, setSortOrder] = useState(null);
  const [payloadCadastro, setPayloadCadastro] = useState({});

  const [grupoAlterado, setGrupoAlterado] = useState('');
  const [campoAlterado, setCampoAlterado] = useState('');
  const [valorAlterado, setValorAlterado] = useState('');
  const [nroItemAlterado, setNroItemAlterado] = useState('');

  const [columnsSetup] = useState([
    { field: 'data', header: 'Data', sort: true },
    { field: 'serie', header: 'Série', sort: false },
    { field: 'numeroCt', header: 'Número', sort: true },
    { field: 'chaveAcesso', header: 'Chave de Acesso', sort: true },
    { field: 'tomador.razaoSocial', header: 'Tomador', sort: false },
    { field: 'totalVNF', header: 'Total NF-e', sort: false },
    { field: 'codSit', header: 'Situação', sort: false },
    { field: 'tpCTe', header: 'Finalidade', sort: false },
    { field: 'flag', header: 'Enviada', sort: true },
  ]);

  const [columnsSetupCartaCorrecao] = useState([
    { field: 'chaveAcesso', header: 'Chave Acesso', sort: false },
    { field: 'data', header: 'Data Evento', sort: false },
    { field: 'sequencia', header: 'Sequência Evento', sort: false },
    { field: 'grupoAlterado', header: 'Grupo', sort: false },
    { field: 'campoAlterado', header: 'Campo', sort: false },
    { field: 'valorAlterado', header: 'Valor', sort: false },
    { field: 'nroItemAlterado', header: 'Ítem', sort: false },
  ]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: null,
  });

  addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'hoje',
    clear: 'Limpar',
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function getData(searchFilter, filtrarCnpjEmpresa, page, size) {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/cte/search?idUsuario=${idUsuario}`;

      if (filtrarCnpjEmpresa !== '') {
        params = `${params}&cnpjEmpresa=${filtrarCnpjEmpresa}`;
      }

      if (searchFilter && searchFilter.findDataInicial !== '') {
        const _dataInicial = dateFormat(searchFilter.findDataInicial, 'dd-mm-yyyy');

        const _dataFinal = dateFormat(searchFilter.findDataFinal, 'dd-mm-yyyy');
        params = `${params}&dataInicial=${_dataInicial}&dataFinal=${_dataFinal}`;
      }

      params = `${params}&page=${page}&size=${size}`;

      const response = await axiosAdmin.get(params);

      // console.log('response: ', response.data.content);

      setDataTableList(response.data.content);
      setTotalRecords(response.data.totalElements);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  async function getDataCartaCorrecao(chave) {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      let params = `/evento?idUsuario=${idUsuario}`;

      if (cnpjEmpresa !== '') {
        params = `${params}&cnpjEmpresa=${cnpjEmpresa}`;
      }

      params = `${params}&chaveAcesso=${chave}&tipo=CARTACORRECAO`;

      const response = await axiosAdmin.get(params);

      // console.log('cartas correcao: ', response.data);

      setDataTableListCartaCorrecao(response.data);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = { findDataInicial, findDataFinal };

    const _lazyParams = { ...lazyParams, first: 0, page: 0 };

    setLazyParams(_lazyParams);

    getData(searchFilter, cnpjEmpresa, 0, lazyParams.rows);
  };

  useEffect(() => {
    async function verificarSeMultiEmpresa(idUsuario, searchFilter) {
      try {
        setIsLoading(true);

        const params = `/usuario/${idUsuario}`;

        const response = await axiosAdmin.get(params);

        const _listaEmpresas = get(response.data, 'listaEmpresas', []);

        const listDropdown = [];

        const _cnpjConsultaPrevisaoFinanceiraCjpEmpresa = store.getState().auth.consultaPrevisaoFinanceiraCnpjEmpresa;

        let cnpjPreenchido = false;
        let _cnpjEmpresaStore = get(store.getState().auth, 'cnpjEmpresa', '');

        if (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '') {
          if (_cnpjEmpresaStore !== null && _cnpjEmpresaStore !== '') {
            setCnpjEmpresa(_cnpjEmpresaStore);
            const consultaPrevisaoFinanceiraCnpjEmpresa = _cnpjEmpresaStore;
            dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
            cnpjPreenchido = true;
          }
        }

        _listaEmpresas.forEach(element => {
          if (!cnpjPreenchido && (_cnpjConsultaPrevisaoFinanceiraCjpEmpresa === null || _cnpjConsultaPrevisaoFinanceiraCjpEmpresa === '')) {
            setCnpjEmpresa(element.cnpj);
            setSerieEmpresa(element.nfeSerie);
            setUfEmpresa(element.uf);
            // eslint-disable-next-line no-unused-expressions
            const consultaPrevisaoFinanceiraCnpjEmpresa = element.cnpj;
            dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
            _cnpjEmpresaStore = element.cnpj;
            cnpjPreenchido = true;
          }

          listDropdown.push(
            {
              label: element.razaoSocial.trim(),
              value: element.cnpj,
              serie: element.nfeSerie,
              uf: element.uf,
              nfeAmbiente: element.nfeAmbiente,
              cteAmbiente: element.cteAmbiente,
              aliquotaCofins: element.aliquotaCofins,
              aliquotaPis: element.aliquotaPis,
              id: element.id,
              moduloCte: element.moduloCte,
            });
        });

        if (!isEmpty(empresaCnpj)) {
          _cnpjEmpresaStore = empresaCnpj;
          setCnpjEmpresa(empresaCnpj);
        }

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaEmpresas(listDropdown);

        if (!cnpjPreenchido && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== null && _cnpjConsultaPrevisaoFinanceiraCjpEmpresa !== '') {
          setCnpjEmpresa(_cnpjConsultaPrevisaoFinanceiraCjpEmpresa);
          _cnpjEmpresaStore = _cnpjConsultaPrevisaoFinanceiraCjpEmpresa;
        }

        getData(searchFilter, _cnpjEmpresaStore, 0, lazyParams.rows);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    if (findDataInicial === null) {
      setFindDataInicial(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial));
      setFindDataFinal(new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal));

      const _dataInicial = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataInicial);
      const _dataFinal = new Date(store.getState().auth.consultaPrevisaoFinanceiraDataFinal);

      const searchFilter = { findDataInicial: _dataInicial, findDataFinal: _dataFinal };

      verificarSeMultiEmpresa(get(store.getState().auth.user, 'id', 0), searchFilter);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    listaEmpresas.forEach(element => {
      // console.log('empresa: ', element);
      if (element.value === cnpjEmpresa) {
        // eslint-disable-next-line no-unused-expressions
        element.cteAmbiente === 'PRODUCAO' ? setEmpresaTipoAmbiente('Produção') : setEmpresaTipoAmbiente('AMBIENTE DE HOMOLOGAÇÃO - SEM VALOR FISCAL');
      }
    });
    const searchFilter = { findDataInicial, findDataFinal };
    getData(searchFilter, cnpjEmpresa, 0, lazyParams.rows);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cnpjEmpresa, listaEmpresas]);

  async function licencaValida(empresaId) {
    // eslint-disable-next-line consistent-return
    const retorno = await axiosAdmin.get(`/empresa/verificardatalicenca/${empresaId}`);
    return retorno.data;
  }

  // eslint-disable-next-line no-shadow, consistent-return
  const handleRegister = async (arquivoXml) => {
    const id = 0;

    let seriePadrao = '1';
    let uf = '';
    let aliquotaPis = 0;
    let aliquotaCofins = 0;
    let empresaId = 0;
    let moduloCte = false;

    listaEmpresas.forEach(element => {
      if (element.value === cnpjEmpresa) {
        // eslint-disable-next-line no-unused-expressions
        (element.serie !== '') ? seriePadrao = element.serie : '';
        uf = element.uf;
        aliquotaCofins = element.aliquotaCofins;
        aliquotaPis = element.aliquotaPis;
        empresaId = element.id;
        moduloCte = element.moduloCte;
      }
    });

    if (!moduloCte) {
      toast.info('Módulo Emissor de CT-e não liberado.');
      return false;
    }

    const isLicencaValida = await licencaValida(empresaId);
    if (!isLicencaValida) {
      toast.info('Cliente com licença expirada. Efetuar pagamento mensalidade.');
      navigate('/pagamento');
      return false;
    }

    setPayloadCadastro(
      {
        id,
        cnpjEmpresa,
        seriePadrao,
        uf,
        chaveAcesso,
        arquivoXml,
        aliquotaPis,
        aliquotaCofins,
      },
    );

    setShowCadastro(true);
  };

  // eslint-disable-next-line consistent-return
  const handleEdit = async (e) => {
    e.preventDefault();

    let seriePadrao = '1';
    let uf = 'MG';
    let empresaId = 0;

    listaEmpresas.forEach(element => {
      if (element.value === cnpjEmpresa) {
        // eslint-disable-next-line no-unused-expressions
        (element.serie !== '') ? seriePadrao = element.serie : '';
        uf = element.uf;
        empresaId = element.id;
      }
    });

    const isLicencaValida = await licencaValida(empresaId);
    if (!isLicencaValida) {
      toast.info('Cliente com licença expirada. Efetuar pagamento mensalidade.');
      navigate('/pagamento');
      return false;
    }

    const id = get(selectedItens, 'id', 0);
    const codigoSituacao = get(selectedItens, 'codSit', 0);
    const enviada = get(selectedItens, 'flag', 0);

    if (codigoSituacao === 'CANCELADO') {
      toast.warn('Nota cancelada não pode ser editada');
      return false;
    }

    if (codigoSituacao === 'DENEGADO') {
      toast.warn('Nota DENEGADA não pode ser editada');
      return false;
    }

    if (codigoSituacao === 'DENEGADO') {
      toast.warn('Nota DENEGADA não pode ser editada');
      return false;
    }

    if (enviada === 'T') {
      toast.warn('CT-e enviado nao pode ser editado');
      return false;
    }

    if (id > 0) {
      setPayloadCadastro({ id, cnpjEmpresa, enviada, seriePadrao, uf });
      setShowCadastro(true);
    } else {
      toast.warning('Por favor, selecione o registro para edição');
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    const enviada = get(selectedItens, 'flag', 0);

    const codSit = get(selectedItens, 'codSit', 0);

    // console.log('codSit: ', codSit);

    if (codSit === 'CANCELADO') {
      toast.warn('Nota cancelada não pode ser excluída');
      return;
    }

    if (enviada === 'T') {
      toast.warn('Nota enviada não pode ser excluída');
      return;
    }

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      setShowConfirmDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para exclusão');
    }
  };

  const handleCartaCorrecao = (e) => {
    const enviada = get(e, 'flag', 0);
    const codigoSituacao = get(e, 'codSit', 0);
    setChaveAcesso(get(e, 'chaveAcesso', 0));
    setCnpjCartaCorrecao(cnpjEmpresa);
    setIdSelecionado(get(e, 'id', 0));

    if (enviada !== 'T') {
      toast.warn('Somente Nota enviada pode ter carta de correção.');
      return;
    }
    if (codigoSituacao !== 'REGULAR') {
      toast.warn('Somente notas regulares podem ter carta de correção.');
      return;
    }

    const id = get(e, 'id', 0);

    if (id > 0) {
      getDataCartaCorrecao(get(e, 'chaveAcesso', 0));
      setShowConfirmCartaCorrecaoDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para criar a carta de correção');
    }
  };

  const handleCancelamento = (e) => {
    const enviada = get(e, 'flag', 0);
    const codigoSituacao = get(e, 'codSit', 0);
    setIdSelecionado(get(e, 'id', 0));

    if (enviada !== 'T') {
      toast.warn('Somente Nota enviada pode ser cancelada');
      return;
    }

    if (codigoSituacao === 'CANCELADO') {
      toast.warn('Nota já esta cancelada.');
      return;
    }

    const id = get(e, 'id', 0);

    if (id > 0) {
      setShowConfirmCancelamentoDialog(true);
    } else {
      toast.warning('Por favor, selecione o registro para cancelamento');
    }
  };

  const cancelCancelamento = () => {
    setShowConfirmCancelamentoDialog(false);
    setMotivoCancelamento('');
  };

  const cancelCartaCorrecao = () => {
    setShowConfirmCartaCorrecaoDialog(false);
  };

  const cancelDelete = () => {
    setShowConfirmDialog(false);
  };

  const confirmDelete = async () => {
    setShowConfirmDialog(false);

    try {
      setIsLoading(true);

      const idExclusao = get(selectedItens, 'id', 0);

      if (idExclusao > 0) {
        await axiosAdmin.delete(`/cte/${idExclusao}`);

        const _itens = dataTableList.filter(val => val.id !== idExclusao);
        setDataTableList(_itens);

        toast.success('Registro excluído com sucesso');
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível excluir o registro');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmCartaCorrecao = async () => {
    if (grupoAlterado.length < 1) {
      toast.info('Grupo Alteração da carta de correção inválido.');
      return;
    }

    if (campoAlterado.length < 1) {
      toast.info('Campo Alteração da carta de correção inválido.');
      return;
    }

    if (valorAlterado.length < 1) {
      toast.info('Valor Alteração da carta de correção inválido.');
      return;
    }

    if (sequenciaEventoCartaCorrecao.length < 1) {
      toast.info('Número Sequencial da carta de correção inválido.');
      return;
    }

    setShowConfirmCartaCorrecaoDialog(false);

    try {
      setIsLoading(true);

      const id = idSelecionado;

      if (id > 0) {
        await axiosAdmin.get(`/cteutil/cartacorrecaocte?id=${id}&grupo=${grupoAlterado}&cnpj=${cnpjCartaCorrecao}&sequencia=${sequenciaEventoCartaCorrecao}&campo=${campoAlterado}&valor=${valorAlterado}&item=${nroItemAlterado}`);

        toast.success('Registro Cartao Correção realizado com sucesso');
        handleFind();
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível registrar a carta de correção');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmCancelamento = async () => {
    if (motivoCancelamento.length < 15) {
      toast.warn('Motivo cancelamento deve conter no mínimo 15 caracteres.');
      return;
    }

    setShowConfirmCancelamentoDialog(false);

    try {
      setIsLoading(true);

      const id = idSelecionado;

      if (id > 0) {
        await axiosAdmin.get(`/cteutil/cancelarcte?id=${id}&motivo=${motivoCancelamento}`);

        toast.success('Cancelamento registrado com sucesso');
        handleFind();
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível cancelar o CT-e');
    } finally {
      setIsLoading(false);
    }
  };

  const downloadPdf = (response, chave) => {
    try {
      const byteCharacters = Base64.atob(response.data);

      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blobFile = new Blob([byteArray], { type: 'application/pdf' });

      listaArquivosZipar.push({ file: blobFile, fileName: chave + '.pdf' });
    } catch (e) {
      toast.warn('Erro ao adicionar o pdf ao arquivo .zip');
    }
  };

  const visualizarPdf = (response) => {
    try {
      const byteCharacters = Base64.atob(response.data);

      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blobFile = new Blob([byteArray], { type: 'application/pdf' });

      const pdf = URL.createObjectURL(blobFile);
      window.open(pdf);
    } catch (e) {
      toast.warn('Erro ao adicionar o pdf ao arquivo .zip');
    }
  };

  const handleVisualizarPdf = async (e) => {
    if (e.codSit === 'DENEGADO') {
      toast.info('Nota Denegada não pode ser impressa.');
      return;
    }

    try {
      setIsLoading(true);

      const id = get(e, 'id', 0);
      const chave = get(e, 'chaveAcesso', 0);

      if (id > 0) {
        await axiosAdmin.get(`/cteutil/downloaddacte?chaveacesso=${chave}`).then(res => {
          visualizarPdf(res, chave);
        });
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível baixar os arquivos');
    } finally {
      setIsLoading(false);
    }
  };

  const downloadXml = (responseXml, chave) => {
    try {
      const byteCharactersXml = Base64.atob(responseXml.data);

      const byteNumbersXml = new Array(byteCharactersXml.length);
      for (let i = 0; i < byteCharactersXml.length; i++) {
        byteNumbersXml[i] = byteCharactersXml.charCodeAt(i);
      }

      const byteArrayXml = new Uint8Array(byteNumbersXml);

      const blobFileXml = new Blob([byteArrayXml], { type: 'application/xml' });

      listaArquivosZipar.push({ file: blobFileXml, fileName: chave + '.xml' });
    } catch (e) {
      toast.info('Erro ao adicionar o arquivo xml ao .zip');
    }
  };

  const handleDownloadPdf = async (e) => {
    try {
      const id = get(e, 'id', 0);
      const chave = get(e, 'chaveAcesso', 0);

      if (id > 0) {
        await axiosAdmin.get(`/cteutil/downloaddacte?chaveacesso=${chave}`).then(res => {
          downloadPdf(res, chave);
        });
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível baixar os arquivos');
    }
  };

  const handleDownloadXml = async (e) => {
    try {
      const id = get(e, 'id', 0);
      const chave = get(e, 'chaveAcesso', 0);

      if (id > 0) {
        await axiosAdmin.get(`/xml/obterxml?chaveacesso=${chave}`).then(res => {
          downloadXml(res, chave);
        });
      }
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível baixar os arquivos');
    }
  };

  const criarEBaixarArquivoZip = async (arquivos, chave) => {
    try {
      const zip = new JSZip();

      arquivos.forEach(element => {
        zip.file(element.fileName, element.file);
      });

      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, chave + '.zip');
      });

      setListaArquivosZipar([]);

      toast.success('Arquivo baixado com sucesso!');
    } catch (e) {
      toast.warn('Erro ao baixar arquivo zip.');
    }
  };

  const handleSalvarArquivos = async (e) => {
    if (e.codSit === 'DENEGADO') {
      toast.info('Nota Denegada não pode ser impressa.');
      return;
    }

    try {
      setIsLoading(true);
      const chave = get(e, 'chaveAcesso', 0);
      await handleDownloadXml(e);
      await handleDownloadPdf(e);
      await criarEBaixarArquivoZip(listaArquivosZipar, chave);
    } catch (err) {
      toast.warn('Não foi possível fazer download dos arquivos.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleImprimirCartaCorrecao = async (e) => {
    try {
      setIsLoading(true);

      // eslint-disable-next-line prefer-destructuring
      const modelo = e.modelo;
      // eslint-disable-next-line prefer-destructuring
      const serie = e.serie;
      const numero = e.chaveAcesso.substring(25, 34);
      const dataEvento = ('00' + e.data[2]).slice(-2) + '/' + ('00' + e.data[1]).slice(-2) + '/' + e.data[0];
      const dataEmissaoCarta = dataEvento;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF('landscape');

      doc.autoTable({
        styles: { fontSize: 10 },
        margin: { bottom: 58, top: 38, left: 5, right: 5 },
        theme: 'grid',
        head: '',
        body: [],
        didDrawPage: (_dados) => {
          // Header
          doc.rect(5, 5, 287, 30);

          doc.setFontSize(20);
          doc.text('CARTA DE CORREÇÃO ELETRÔNICA', 85, 15);
          doc.setFontSize(15);
          doc.text('Não possui valor fiscal. Simples Representação do evento indicado abaixo', 57, 23);
          doc.setFontSize(15);
          doc.text('CONSULTE A AUTENTICIDADE NO SITE DA SEFAZ AUTORIZADORA', 58, 30);

          doc.setFontSize(15);
          doc.text('Conhecimento de Transporte Eletrônico - CT-e', 5, 43);

          // quadro nota fiscal
          doc.rect(5, 46, 287, 30);

          // modelo
          doc.rect(5, 46, 50, 15);
          doc.setFontSize(10);
          doc.text('MODELO', 7, 51);
          doc.setFontSize(20);
          doc.text(modelo, 25, 58);

          // serie
          doc.rect(55, 46, 50, 15);
          doc.setFontSize(10);
          doc.text('SÉRIE', 57, 51);
          doc.setFontSize(20);
          doc.text(serie, 70, 58);

          // numero
          doc.rect(105, 46, 90, 15);
          doc.setFontSize(10);
          doc.text('NÚMERO', 107, 51);
          doc.setFontSize(20);
          doc.text(numero, 125, 58);

          // data emissao
          doc.rect(195, 46, 97, 15);
          doc.setFontSize(10);
          doc.text('MÊS/ANO DA EMISSÃO', 197, 51);
          doc.setFontSize(20);
          doc.text(dataEmissaoCarta, 225, 58);

          // chaveacesso
          doc.rect(5, 61, 287, 15);
          doc.setFontSize(10);
          doc.text('CHAVE DE ACESSO', 7, 66);
          doc.setFontSize(20);
          doc.text(e.chaveAcesso, 55, 72);

          doc.setFontSize(15);
          doc.text('CARTA DE CORREÇÃO ELETRÔNICA', 5, 83);

          // quadro carta correcao
          doc.rect(5, 86, 287, 15);

          // orgão
          doc.rect(5, 86, 50, 15);
          doc.setFontSize(10);
          doc.text('ÓRGÃO', 7, 91);
          doc.setFontSize(20);
          doc.text(e.codigoOrgao, 25, 98);

          // data do evento
          doc.rect(55, 86, 140, 15);
          doc.setFontSize(10);
          doc.text('DATA DO EVENTO', 108, 91);
          doc.setFontSize(20);
          doc.text(dataEvento, 115, 98);

          // sequencia
          doc.rect(195, 86, 97, 15);
          doc.setFontSize(10);
          doc.text('SEQUÊNCIA DO EVENTO', 198, 91);
          doc.setFontSize(20);
          doc.text(e.sequencia, 235, 98);

          // quadro grupo, campo e numero item
          doc.rect(5, 106, 287, 15);

          // Grupo
          doc.rect(5, 106, 95, 15);
          doc.setFontSize(10);
          doc.text('GRUPO', 7, 111);
          doc.setFontSize(15);
          doc.text(e.grupoAlterado, 10, 118);

          // campo
          doc.rect(100, 106, 95, 15);
          doc.setFontSize(10);
          doc.text('CAMPO', 105, 111);
          doc.setFontSize(15);
          doc.text(e.campoAlterado, 109, 118);

          // numero do item
          doc.rect(195, 106, 97, 15);
          doc.setFontSize(10);
          doc.text('NÚMERO ÍTEM', 199, 111);
          doc.setFontSize(15);
          doc.text(e.nroItemAlterado, 204, 118);

          doc.setFontSize(15);
          doc.text('MOTIVO DA CARTA DE CORREÇÃO', 5, 130);

          // quadro carta correcao
          doc.rect(5, 133, 287, 50);

          doc.setFontSize(14);
          doc.text(e.valorAlterado.substring(0, 120), 8, 138);
          doc.text(e.valorAlterado.substring(120, 240), 8, 144);
          doc.text(e.valorAlterado.substring(240, 360), 8, 150);
          doc.text(e.valorAlterado.substring(360, 480), 8, 156);
          doc.text(e.valorAlterado.substring(480, 600), 8, 162);

          // footer
          doc.setFontSize(8);
          const { pageSize } = doc.internal;
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(`Pag ${doc.internal.getNumberOfPages()}`, _dados.settings.margin.right, pageHeight - 8);
          const periodo = new Date();
          doc.text('Impresso: ', 255, pageHeight - 8);
          // eslint-disable-next-line prefer-template
          doc.text((`${('00' + periodo.getDate()).slice(-2)}/${('00' + (+periodo.getMonth() + 1)).slice(-2)}/${periodo.getFullYear()}`).toString(), 270, pageHeight - 8);
        },
      });
      window.open(doc.output('bloburl'));
    } catch (err) {
      // console.log(err);
      displayErrors(err, dispatch, navigate, '', 'Não foi possível imprimir a carta de correção');
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDialogFooter = (
    <div>
      <Button className="btn-success" label="Sim" icon="pi pi-check" onClick={confirmDelete} />
      <Button label="Não" icon="pi pi-times" onClick={cancelDelete} />
    </div>
  );

  const confirmCancelamentoDialogFooter = (
    <div>
      <Button className="btn-success" label="Sim" icon="pi pi-check" onClick={confirmCancelamento} />
      <Button label="Não" icon="pi pi-times" onClick={cancelCancelamento} />
    </div>
  );

  const confirmCartaCorrecaoDialogFooter = (
    <div>
      <Button className="btn-success" label="Sim" icon="pi pi-check" onClick={confirmCartaCorrecao} />
      <Button label="Não" icon="pi pi-times" onClick={cancelCartaCorrecao} />
    </div>
  );

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const onPage = (event) => {
    setLazyParams(event);

    const searchFilter = { findDataInicial, findDataFinal };

    getData(searchFilter, cnpjEmpresa, event.page, event.rows);
  };

  const onHideCadastro = () => {
    setShowCadastro(false);
  };

  const childToParentConsulta = (payloadDataTableList, id) => {
    if (payloadDataTableList) {
      if (id > 0) {
        const index = dataTableList.map(e => e.id).indexOf(id);

        if (index >= 0) {
          dataTableList[index] = payloadDataTableList;
        }
      } else {
        const _dataTableList = [];
        _dataTableList.push(payloadDataTableList);

        setDataTableList(_dataTableList);

        const _lazyParams = { ...lazyParams, first: 0, page: 0 };
        setLazyParams(_lazyParams);
        setTotalRecords(1);
      }
    }

    setShowCadastro(false);
  };

  const actionBodyTemplate = (rowData) => {
    if (rowData.flag === 'T') {
      return (
        <div className="row col-12">
          <div className="col-lg-3">
            <button
              type="button"
              title="Visualizar PDF"
              className="btn-dark rounded outlined"
              style={{ borderRadius: '15px' }}
              onClick={() => handleVisualizarPdf(rowData)}
            >
              <i className="pi pi-eye"></i>
            </button>
          </div>
          <div className="col-lg-3">
            <button
              type="button"
              title="Download PDF/XML"
              className="btn-success rounded outlined"
              style={{ borderRadius: '15px' }}
              onClick={() => handleSalvarArquivos(rowData)}
            >
              <i className="pi pi-download"></i>
            </button>
          </div>
          <div className="col-lg-3">
            <button
              type="button"
              title="Criar Carta de Correção"
              className="btn-info rounded outlined"
              style={{ borderRadius: '15px' }}
              onClick={() => handleCartaCorrecao(rowData)}
            >
              <i className="pi pi-envelope"></i>
            </button>
          </div>
          <div className="col-lg-3">
            <button
              type="button"
              title="Efetuar Cancelamento"
              className="btn-danger rounded outlined"
              style={{ borderRadius: '15px' }}
              onClick={() => handleCancelamento(rowData)}
            >
              <i className="pi pi-ban"></i>
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row col-12">
          <div className="col-lg-3">
            <button
              type="button"
              title="Visualizar PDF"
              className="btn-dark rounded outlined"
              style={{ borderRadius: '15px' }}
              onClick={() => handleVisualizarPdf(rowData)}
            >
              <i className="pi pi-eye"></i>
            </button>
          </div>
        </div>
      );
    }
  };

  const actionBodyTemplateCartaCorrecao = (rowData) => (
    <div className="row col-12">
      <div className="col-lg-4">
        <button
          type="button"
          title="Imprimir Carta Correção"
          className="btn-success rounded outlined"
          style={{ borderRadius: '15px' }}
          onClick={() => handleImprimirCartaCorrecao(rowData)}
        >
          <i className="pi pi-print"></i>
        </button>
      </div>
    </div>
  );

  const renderTipoAmbiente = () => {
    if (empresaTipoAmbiente === 'AMBIENTE DE HOMOLOGAÇÃO - SEM VALOR FISCAL') {
      return (
        <h6 className="card-header" style={{ textAlign: 'center' }}>
          {empresaTipoAmbiente}
        </h6>
      );
    }
    return '';
  };

  const getConversaoCfop = async (cfop, cst) => {
    try {
      const idUsuario = get(store.getState().auth.user, 'id', 0);
      const response = await axiosAdmin.get(`/conversaocfop?idUsuario=${idUsuario}&cfopOrigem=${cfop}&cstOrigem=${cst}`);
      return response;
    } catch (e) {
      toast.info('Não foi possível pegar a conversão de cfop');
    }
    return null;
  };

  const isNFeItensOk = async () => {
    let isOk = true;
    dataTableListNFeItem.forEach(element => {
      if (parseFloat(element.registro) > 0 && element.descricao && parseFloat(element.qtdePorCx) > 0 && element.cfopDestino && element.cstDestino) {
        element.ok = 'Ok';
      } else {
        isOk = false;
      }
    });
    return isOk;
  };

  useEffect(() => {
    async function verifica() {
      await isNFeItensOk(dataTableListNFeItem);
    }
    verifica();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTableListNFeItem]);

  const verificaNovaConversaoCfop = async (lista) => {
    lista.forEach(async element => {
      await getConversaoCfop(element.cfop, element.cst).then(resp => {
        if (resp.data.length > 0) {
          element.cfopDestino = resp.data[0].cfopDestino;
          element.cstDestino = resp.data[0].cstDestino;
        }
      });
      setDataTableListNFeItem([...lista]);
    });
  };

  const onHideConsultaConversaoCfop = async () => {
    await verificaNovaConversaoCfop(dataTableListNFeItem);
    setShowConsultaConversaoCfop(false);
  };

  const childToParentConsultaConversaoCfop = async () => {

  };

  function renderBotaoSelect() {
    if (!menuMode) {
      return (
        <button
          type="button"
          title="Selecionar"
          className="btn btn-info"
          style={{ borderRadius: '15px' }}
          onClick={() => childToParent(selectedItens)}
        >
          <i className="pi pi-check"></i>
        </button>
      );
    }
    return '';
  }

  const handleClonarCte = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);

    if (id > 0) {
      const clonar = true;

      setPayloadCadastro({ id, clonar, cnpjEmpresa });
      setShowCadastro(true);
    } else {
      toast.warning('Por favor, selecione o pedido para clonagem');
    }
  };

  return (
    <>
      <Loading isLoading={isLoading} />

      <Dialog
        header="Cadastro Conversão CFOP"
        visible={showConsultaConversaoCfop}
        style={{ width: '98vw' }}
        onHide={() => onHideConsultaConversaoCfop()}
      >
        <ConsultaConversaoCfop menuMode={false} childToParent={childToParentConsultaConversaoCfop} empresaCnpj={cnpjEmpresa} />
      </Dialog>

      <Dialog
        header=""
        closeOnEscape={false}
        visible={showCadastro}
        style={{ width: '98vw' }}
        onHide={() => onHideCadastro()}
        className="dialog-cadastro"
      >
        <CadastroCte payloadCadastro={payloadCadastro} childToParentConsulta={childToParentConsulta} />
      </Dialog>

      <Card>
        <div>
          <div className="card mb-3">
            <h6 className="card-header" style={{ textAlign: 'center' }}>
              Conhecimento de Transporte Eletrônico - Digitação
            </h6>
            {renderTipoAmbiente()}

          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data inicial
                </Input100px>
                <Calendar
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataInicial}
                  onChange={(e) => {
                    setFindDataInicial(e.value);
                    const consultaPrevisaoFinanceiraDataInicial = e.value;
                    const consultaPrevisaoFinanceiraDataFinal = findDataFinal;
                    dispatch(actions.consultaPrevisaoFinanceiraDataInicialChange({ consultaPrevisaoFinanceiraDataInicial, consultaPrevisaoFinanceiraDataFinal }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="p-inputgroup">
                <Input100px className="p-inputgroup-addon">
                  Data final
                </Input100px>
                <Calendar
                  showIcon
                  mask="99/99/9999"
                  dateFormat="dd/mm/yy"
                  showButtonBar
                  showOnFocus={false}
                  locale="pt-BR"
                  value={findDataFinal}
                  onChange={(e) => {
                    setFindDataFinal(e.value);
                    const consultaPrevisaoFinanceiraDataInicial = findDataInicial;
                    const consultaPrevisaoFinanceiraDataFinal = e.value;
                    dispatch(actions.consultaPrevisaoFinanceiraDataInicialChange({ consultaPrevisaoFinanceiraDataInicial, consultaPrevisaoFinanceiraDataFinal }));
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3">
              {listaEmpresas.length > 1 ? (
                <div className="p-inputgroup">
                  <Input100px className="p-inputgroup-addon">
                    Empresa
                  </Input100px>
                  <Dropdown
                    options={listaEmpresas}
                    value={cnpjEmpresa}
                    emptyMessage="Nenhum registro a ser exibido"
                    onChange={(e) => {
                      setCnpjEmpresa(e.target.value);
                      const consultaPrevisaoFinanceiraCnpjEmpresa = e.target.value;
                      dispatch(actions.consultaPrevisaoFinanceiraCnpjEmpresaChange({ consultaPrevisaoFinanceiraCnpjEmpresa }));
                    }}
                  />
                </div>
              ) : ('')}
            </div>
            <div className="col-lg-3">
              <button
                type="button"
                title="Buscar"
                className="btn btn-success"
                style={{ borderRadius: '15px' }}
                onClick={handleFind}
              >
                <i className="pi pi-search"></i>
              </button>
              <button
                type="button"
                title="Cadastrar"
                className="btn btn-primary"
                style={{ borderRadius: '15px' }}
                onClick={handleRegister}
              >
                <i className="pi pi-plus"></i>
              </button>
              <button
                type="button"
                title="Editar"
                className="btn btn-warning"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleEdit(e)}
              >
                <i className="pi pi-pencil"></i>
              </button>
              <button
                type="button"
                title="Clonar Pedido"
                className="btn btn-secondary"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleClonarCte(e)}
              >
                <i className="pi pi-clone"></i>
              </button>
              <button
                type="button"
                title="Excluir"
                className="btn btn-danger"
                style={{ borderRadius: '15px' }}
                onClick={(e) => handleDelete(e)}
              >
                <i className="pi pi-trash"></i>
              </button>
              {renderBotaoSelect()}
            </div>
          </div>
        </div>
        <br />

        <div className="card">
          <DataTable
            value={dataTableList}
            size="small"
            stripedRows
            responsiveLayout="scroll"
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            selectionMode="single"
            selection={selectedItens}
            onSelectionChange={e => setSelectedItens(e.value)}
            selectableRows
            dataKey="id"
            paginator
            lazy
            first={lazyParams.first}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPage}
            emptyMessage="Nenhum registro a ser exibido"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
            rowsPerPageOptions={[10, 25, 50]}
          >
            {fillColumns(columnsSetup)}
            <Column body={actionBodyTemplate} exportable={false} style={{ width: '170px' }}></Column>
          </DataTable>
        </div>

        <Dialog
          header="Confirmação"
          visible={showConfirmDialog}
          style={{ width: '50vw' }}
          footer={confirmDialogFooter}
          onHide={() => setShowConfirmDialog(false)}
        >
          <p>
            Excluir o registro?
          </p>
        </Dialog>

        <Dialog
          header={<h6 className="card-header" style={{ textAlign: 'center' }}>Carta de Correção</h6>}
          visible={showConfirmCartaCorrecaoDialog}
          style={{ width: '90vw' }}
          footer={confirmCartaCorrecaoDialogFooter}
          onHide={() => setShowConfirmCartaCorrecaoDialog(false)}
        >
          <div className="row form-elo">
            <div className="col-12">
              <p> A Carta de Correção é disciplinada pelo Art. 58 B do CONVÊNIO/SINIEF 06/89: Fica permitida a
                utilização de carta de correção, para regularização de erro ocorrido na emissão de
                documentos fiscais relativos à prestação de serviço de transporte, desde que o erro não esteja
                relacionado com: <br /> I - as variáveis que determinam o valor do imposto tais como: base de cálculo,
                alíquota, diferença de preço, quantidade, valor da prestação; <br /> II - a correção de dados cadastrais que
                implique mudança do emitente, tomador, remetente ou do destinatário; <br /> III - a data de emissão ou de saída.”
              </p>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-6">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Chave de Acesso
                </Input200px>
                <InputText
                  disabled
                  maxLength={50}
                  value={chaveAcesso}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Código do orgão da recepção do evento
                </Input200px>
                <InputText
                  disabled
                  maxLength={2}
                  value={chaveAcesso.substring(0, 2)}
                />
              </div>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-6">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  CNPJ ou CPF do autor do evento
                </Input200px>
                <InputText
                  disabled
                  maxLength={14}
                  value={cnpjCartaCorrecao}
                  onChange={e => setCnpjCartaCorrecao(e.target.value)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Sequência do evento
                </Input200px>
                <InputText
                  maxLength={5}
                  value={sequenciaEventoCartaCorrecao}
                  onChange={e => setSequenciaEventoCartaCorrecao(e.target.value)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Id do Lote de envio
                </Input155px>
                <InputText
                  maxLength={5}
                  value={numeroLoteCartaCorrecao}
                  onChange={e => setNumeroLoteCartaCorrecao(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-4">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Grupo Alterado
                </Input155px>
                <InputText
                  maxLength={20}
                  value={grupoAlterado}
                  onChange={e => setGrupoAlterado(e.target.value)}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Campo Alterado
                </Input155px>
                <InputText
                  maxLength={20}
                  value={campoAlterado}
                  onChange={e => setCampoAlterado(e.target.value)}
                />
              </div>
            </div>
            <div className="col-4">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Número Ítem Alterado
                </Input155px>
                <InputNumber
                  onFocus={(e) => e.target.select()}
                  minFractionDigits={0}
                  maxFractionDigits={0}
                  value={nroItemAlterado}
                  onValueChange={e => setNroItemAlterado(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-12">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Descrição da Alteração
                </Input155px>
                <InputText
                  maxLength={499}
                  value={valorAlterado}
                  onChange={e => setValorAlterado(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row form-elo">
            <div className="col-12">
              <DataTable
                value={dataTableListCartaCorrecao}
                size="small"
                stripedRows
                responsiveLayout="scroll"
                sortField={sortField}
                sortOrder={sortOrder}
                onSort={onSort}
                selectionMode="single"
                selection={selectedItens}
                onSelectionChange={e => setSelectedItens(e.value)}
                selectableRows
                dataKey="id"
                paginator
                lazy
                first={lazyParams.first}
                rows={lazyParams.rows}
                totalRecords={totalRecords}
                onPage={onPage}
                emptyMessage="Nenhum registro a ser exibido"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="{currentPage} de {totalPages}"
                rowsPerPageOptions={[10, 25, 50]}
              >
                {fillColumns(columnsSetupCartaCorrecao)}
                <Column body={actionBodyTemplateCartaCorrecao} exportable={false} style={{ width: '50px' }}></Column>
              </DataTable>
            </div>
          </div>
          <p>
            Criar carta de correção?
          </p>
        </Dialog>

        <Dialog
          header={<h6 className="card-header" style={{ textAlign: 'center' }}>Cancelamento da Nota Fiscal</h6>}
          visible={showConfirmCancelamentoDialog}
          style={{ width: '70vw' }}
          footer={confirmCancelamentoDialogFooter}
          onHide={() => setShowConfirmCancelamentoDialog(false)}
        >
          <div className="row form-elo">
            <div className="col-12">
              <div className="p-inputgroup">
                <Input200px className="p-inputgroup-addon">
                  Motivo do Cancelamento
                </Input200px>
                <InputText
                  maxLength={50}
                  value={motivoCancelamento}
                  onChange={e => setMotivoCancelamento(e.target.value)}
                />
              </div>
            </div>
          </div>
          <p>
            Cancelar a Nota Fiscal Selecionada?
          </p>
        </Dialog>
      </Card>
    </>
  );
}
